var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3636 9.86364H5.63635V7.75H25.3636V9.86364Z",
    fill: "#F5DEB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3636 16.9091H5.63635V14.7955H25.3636V16.9091Z",
    fill: "#F5DEB3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3636 23.9545H5.63635V21.8409H25.3636V23.9545Z",
    fill: "#F5DEB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerIcon);
export default __webpack_public_path__ + "static/media/burgerIcon.3dfffd04928fb7f84f86d09f9e0ac9cb.svg";
export { ForwardRef as ReactComponent };